import { useCallback, useMemo, useState } from 'react';

export const usePopoverControls = () => {
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
    null
  );
  const [isOpen, _setIsOpen] = useState(false);
  const setIsOpen = useCallback(
    (newIsOpen: boolean) => {
      _setIsOpen(newIsOpen);
    },
    [_setIsOpen]
  );
  const actions = useMemo(() => {
    return {
      close: () => setIsOpen(false),
    };
  }, [setIsOpen]);
  return {
    referenceElement,
    setReferenceElement,
    isOpen,
    setIsOpen,
    actions,
  };
};
